import { getToken } from '@/utils/KeycloakUtils'
import {
  Configuration,
  DefaultApi,
  type Middleware,
  RatingLinksApiApi
} from 'partner-api'

// Partner-Proxy hat kein Security-Scheme im OpenAPI-Spec, daher ruft der generierte
// Client `configuration.accessToken` nie automatisch auf. Der Bearer-Token wird
// deshalb per Middleware injiziert, KeyId weiterhin über die statischen Headers.
function basePath(): string {
  return globalThis.ENV_CONFIG?.SERVICE_HOSTS.PARTNER_PROXY
}

const authMiddleware: Middleware = {
  async pre({ url, init }) {
    const token = await getToken()
    init.headers = {
      ...(init.headers as Record<string, string>),
      Authorization: `Bearer ${token}`
    }
    return { url, init }
  }
}

function buildConfiguration(): Configuration {
  return new Configuration({
    basePath: basePath(),
    headers: {
      KeyId: globalThis.ENV_CONFIG?.API_KEY
    },
    middleware: [authMiddleware]
  })
}

export const partnerApi = () => new DefaultApi(buildConfiguration())

export const ratingLinksApi = () => new RatingLinksApiApi(buildConfiguration())
